import mutations from './mutations'
import * as actions from './actions'

const state = {
  users: [],
  selected_user : { userID: 0, firstName: '', lastName: '', userName: '', enabled: true, permissions: [] },
  permissions: []
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js